import ApiService from '../common/api.service';

import {
  SEND_ACCESO,
} from './actions.type';

import {
  SUBMITED_ACCESO,
  SENDING_ACCESO,
  SUBMIT_ACCESO_ERROR,
  RESET_SUBMIT_ACCESO_ERRORS,
} from './mutations.type';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
};

const getters = {
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
};

const actions = {
  [SEND_ACCESO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      const toSend = {
        operador_id: data.operador_id,
        asunto: data.asunto,
        nombres_visitante: data.nombres_visitante,
        apellidos_visitante: data.apellidos_visitante,
        nombres_residente: data.nombres_residente,
        apellidos_residente: data.apellidos_residente,
        fecha_esperada: data.fecha_esperada,
        hora_esperada: data.hora_esperada,
        marca_auto: data.marca_auto,
        modelo_auto: data.modelo_auto,
        placas_auto: data.placas_auto,
        color_auto: data.color_auto,
        desarrollo: data.desarrollo,
        subcondominio: data.subcondominio,
        vivienda: data.vivienda,
        autoriza: data.autoriza,
        telefono: data.telefono,
        telefono_visitante: data.telefono_visitante,
        status: data.status,
        tipo_visitante: data.tipo_visitante,
        observaciones: data.observaciones,
        residente_id: data.residente_id,
        vivienda_id: data.vivienda_id,
      };
      ApiService.post('accesos/registration', toSend)
        .then(({ data }) => {
          context.commit(SUBMITED_ACCESO);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SUBMIT_ACCESO_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SUBMITED_ACCESO](state) {
    state.alert = true;
    state.alertMessage = 'Acceso Enviado Correctamente';
    state.alertType = 'success';
  },
  [SENDING_ACCESO](state) {
    state.alert = true;
    state.alertMessage = 'Enviando Acceso';
    state.alertType = 'info';
  },
  [SUBMIT_ACCESO_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
  [RESET_SUBMIT_ACCESO_ERRORS](state) {
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
